module.exports = __webpack_public_path__ + "img/cta-section-image02.56355387.png";